export default __webpack_public_path__ + "static/media/logo-visions.cd1c9688.svg";